/* RESPONSIBLE TEAM: team-data-foundations */
import RulesetLinkSerializer from '../ruleset-link';

export default RulesetLinkSerializer;
